import { render, staticRenderFns } from "./charge-card.vue?vue&type=template&id=a2fe65b2&scoped=true&"
import script from "./charge-card.vue?vue&type=script&lang=js&"
export * from "./charge-card.vue?vue&type=script&lang=js&"
import style0 from "./charge-card.vue?vue&type=style&index=0&id=a2fe65b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fe65b2",
  null
  
)

export default component.exports